import CryptoJS from 'crypto-js'
import { saveData } from '../caching/indexdbManager'
export async function removeFilterFromList(sectionLabel, filterList, filterLabel) {
  for(let sectionFilter of filterList) {
    if(sectionLabel === sectionFilter.label) {
      sectionFilter.data = sectionFilter.data.filter(a=>a.label !== filterLabel)
    }
  } 

  let client_name = JSON.parse(
    CryptoJS.AES.decrypt(
      localStorage.getItem("conceptName"),
      process.env.REACT_APP_PASS
    ).toString(CryptoJS.enc.Utf8)
  )

  await saveData("auienceBuilder", 'abForm', 'favoriteFilters', {
    "selections": filterList,
    "clientName": client_name,
    "ttl": Date.now() + 21600000 // 6 Hours
  })
  return filterList
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/taggingFavoriteFilter/removeFilterFromList.js